import React from 'react';

function Experience() {
  return (
    <section className="experience" id="experience">
      <div className="experience-card">
        <h2>
          <span>Experiences</span>
        </h2>

        <div className="timeline">
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>SYSTEM DEVELOPER INTERN</h3>
              <p><strong>Cloud Manila</strong> | February 2024 – June 2024</p>
              <ul>
                <li>Worked as an intern for 500 hours</li>
                <li>Angular frontend and backend logic using C#</li>
                <li>Designed and optimized SQL stored procedures and triggers</li>
                <li>Worked with staging/testing environments</li>
                <li>Handled QA testing</li>
              </ul>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>MANAGER</h3>
              <p><strong>NOMO NOMO Bubble Tea Shop</strong> | August 2020 – September 2021</p>
              <ul>
                <li>Managed employees and store revenue</li>
                <li>Trained staff for safety and product quality</li>
                <li>Used Google Sheets and Excel for sales tracking</li>
              </ul>
            </div>
          </div>

          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <div className="timeline-content">
              <h3>STAFF MEMBER</h3>
              <p><strong>HG-Premiere International Trading Inc.</strong> | December 2018 – January 2019</p>
              <ul>
                <li>80 hours of On-The-Job Training</li>
                <li>Basic coding using HTML, CSS, and JavaScript</li>
                <li>Organized company documents</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experience;
